/**
 * Document type helpers for module analytics (ventes / achats / inventaire).
 * Archives persist English DB types; legacy UI filters used French aliases.
 */

export function normalizeDocType(type) {
  return String(type || '')
    .trim()
    .replace(/-/g, '_')
    .toLowerCase();
}

function isSupplierDocument(doc) {
  return Boolean(doc?.isSupplier ?? doc?.is_supplier);
}

const SALES_TYPES = new Set(['facture', 'invoice', 'devis', 'quote', 'proforma', 'bon_commande']);

const PURCHASE_TYPES = new Set([
  'bon_achat',
  'purchase',
  'purchase_order',
  'reception_note',
  'reception',
  'reception_achat',
  'return_slip',
]);

/** Sales-side archive documents for analytics. */
export function isSalesAnalyticsDocument(doc) {
  if (!doc) return false;
  const type = normalizeDocType(doc.type);
  if (isSupplierDocument(doc)) {
    return false;
  }
  if (type === 'purchase_order') {
    return true;
  }
  return SALES_TYPES.has(type);
}

/** Purchase-side archive documents for analytics. */
export function isPurchaseAnalyticsDocument(doc) {
  if (!doc) return false;
  const type = normalizeDocType(doc.type);
  if (PURCHASE_TYPES.has(type)) {
    if (type === 'purchase_order') {
      return isSupplierDocument(doc);
    }
    return true;
  }
  if (type === 'purchase_order' && isSupplierDocument(doc)) {
    return true;
  }
  return false;
}
